export default __webpack_public_path__ + "static/illustration-default-member-profile-6f1d4d91253e3d4bda53ed0971dece39.svg";